"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
var _layout = _interopRequireDefault(require("@/layout"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; } /** When your routing table is too long, you can split it into small modules **/
var logRouter = {
  path: "/log",
  component: _layout.default,
  redirect: "/log/gradeHistory",
  alwaysShow: true,
  name: "Logs",
  meta: {
    title: "Logs",
    icon: "templet"
  },
  children: [{
    path: "gradeHistory",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/log/gradeHistory.vue"));
      });
    },
    name: "gradeHistory",
    meta: {
      title: "历史等级"
    }
  }, {
    path: "exportLog",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/log/exportLog.vue"));
      });
    },
    name: "exportLog",
    meta: {
      title: "导出日志"
    }
  }, {
    path: "interfaceLog",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/log/interfaceLog.vue"));
      });
    },
    name: "interfaceLog",
    meta: {
      title: "接口日志"
    }
  }, {
    path: "operator",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/log/operator/sysLog.vue"));
      });
    },
    name: "logOperator",
    meta: {
      title: "操作日志"
    }
  }, {
    path: "blacklist",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/log/blacklist.vue"));
      });
    },
    name: "rateLimitBlacklist",
    meta: {
      title: "限流管理"
    }
  }]
};
var _default = exports.default = logRouter;